<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				{{ len > 0 ? 'Результатов: ' + len : 'Справочник расходов' }}
				<v-spacer></v-spacer>
				<v-text-field
					v-model="search"
					label="Поиск"
					@input="searchDone = false"
					@keyup.enter="doSearch"
					clearable
					single-line
					hide-details>

					<template v-slot:append>
		                <v-tooltip bottom open-delay="1500">
		                  	<template v-slot:activator="{ on }">
		                    	<v-icon v-on="on" @click="doSearch">search</v-icon>
		                  	</template>
							<p>
								Подсказки по поиску
							</p>
							<p>
								<span class="subtitle-1">%</span> заменяет любую последовательность символов
								<br>
								<span class="subtitle-1">_</span> заменят ровно один символ
							</p>
		                </v-tooltip>
		            </template>

				</v-text-field>
				<v-btn
					icon
					v-if="editRight || editDraftRight"
					@click="newItem"
					class="mt-6 ml-4">
					<v-icon>add</v-icon>
				</v-btn>
				<v-menu left offset-x slide-y v-if="editRight || editDraftRight">
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon class="mt-6">
							<v-icon>more_vert</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template>
							<v-list-item @click="getDrafts">
								<v-list-item-action>
									<v-icon>inbox</v-icon>
								</v-list-item-action>
								<v-list-item-title>
									Статьи на модерации
								</v-list-item-title>
							</v-list-item>
							<v-list-item v-if="editRight" to="/expenses-history">
								<v-list-item-action>
					              	<v-icon>history</v-icon>
					            </v-list-item-action>
								<v-list-item-title>
									История поиска
								</v-list-item-title>
							</v-list-item>
						</template>
					</v-list>
				</v-menu>
			</v-card-title>
			<v-data-table
				:headers="headers"
				:items="data"
				:loading="loadingList"
				:no-data-text="searchDone ? 'Ничего не найдено' : ''"
				:items-per-page="25"
				:footer-props="{
					itemsPerPageText: 'Строк на странице',
					itemsPerPageOptions: [10, 25, 50, 100]
				}"
				no-results-text="Ничего не нашлось"
				item-key="id">
				<template v-slot:item="props">
					<tr>
						<td class="text-center" v-if="draftMode">{{ props.item.author }}</td>

						<td class="text-center">{{ props.item.nameEng }}</td>
						<td class="text-center">{{ props.item.nameRus }}</td>
						<td class="text-center nowrap">{{ codes(props.item.dc, props.item.ic) }}</td>
						<td class="text-center">{{ props.item.dcn }}</td>
						<td class="text-center">{{ props.item.icn }}</td>

						<td class="text-center nowrap" v-if="editRight || draftMode">
							<v-icon v-if="editRight && draftMode"
									small
					            	class="mr-2"
					            	@click="approve(props.item)">
					            thumb_up
					        </v-icon>
							<v-icon small
					            	class="mr-2"
					            	@click="edit(props.item)">
					            edit
					        </v-icon>
					        <v-icon small
					            	@click="del(props.item)">
					            delete
					        </v-icon>
						</td>

					</tr>
				</template>
			</v-data-table>
		</v-card>
		<v-dialog v-model="dialogEdit.show" max-width="1000" persistent>
			<v-card>
				<v-form ref="f" v-model="dialogEdit.valid">
		          	<v-card-text>
		            	<v-container>
		              		<v-row >
		                		<v-col cols="12">
		                  			<v-text-field v-model="dialogEdit.item.nameEng"
												  :rules="[rules.required]"
												  label="Name">
									</v-text-field>
		                		</v-col>
		                		<v-col cols="12">
									<v-text-field v-model="dialogEdit.item.nameRus"
												  :rules="[rules.required]"
												  label="Наименование">
									</v-text-field>
		                		</v-col>
		                		<v-col cols="6">
		                  			<v-autocomplete v-model="dialogEdit.item.dc"
											  :items="dc"
											  :rules="[rules.required]"
											  item-value="code"
											  item-text="name"
											  @change="getIc"
											  label="Отдел">
									</v-autocomplete>
		                		</v-col>
		                		<v-col cols="6">
									<v-autocomplete v-model="dialogEdit.item.ic"
											  :items="ic"
											  :rules="[rules.required]"
											  item-value="code"
											  item-text="name"
											  label="Статья">
									</v-autocomplete>
		                		</v-col>
		              		</v-row>
							<v-row>
								<v-col class="pt-6" cols="12" v-if="!editRight">
									Запись будет добавлена после предварительной модерации
								</v-col>
							</v-row>
		            	</v-container>
		          	</v-card-text>
				</v-form>

		        <v-card-actions>
					<v-btn text
						   @click="add"
						   :disabled="!dialogEdit.valid"
						   v-if="dialogEdit.new">
						Добавить
					</v-btn>
					<template v-else>
						<v-btn text
							   @click="saveAndApprove"
							   :disabled="!dialogEdit.valid"
							   v-if="draftMode && editRight">
							Сохранить и согласовать
						</v-btn>
						<v-btn text
							   @click="save"
							   :disabled="!dialogEdit.valid">
							Сохранить
						</v-btn>
					</template>
		            <v-btn text @click="close">Отмена</v-btn>
		        </v-card-actions>
        	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
</style>

<script>
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
		},
		data: () => ({
			loadingList: false,
			loadingItem: false,
			dcLoaded: false,
			dialogEdit: {
				show: false,
				index: 0,
				valid: false,
				new: false,
				item: {
					nameEng: '',
					nameRus: '',
					dc: 0,
					ic: 0
				}
			},
			searchDone: false,
			search: '',
			data: [],
			draftMode: false,
			len: 0,
			// pagination: {
			// 	descending: false,
			// 	page: 1,
			// 	rowsPerPage: 25,
			// 	sortBy: 'nameEng'
			// },
			rules: {
	          	required: value => value !== "" || 'Обязательно'
	        },
			dc: [],
			ic: []
		}),
		computed: {
			headers() {
				let headers = [
					{
						text: 'Expense',
						value: 'nameEng',
						align: 'center',
						sortable: true,
						width: "25%"
					},
					{
						text: 'Расход',
						value: 'nameRus',
						align: 'center',
						sortable: true,
						width: "25%"
					},
					{
						text: 'Коды',
						value: 'dc_ic',
						align: 'center',
						sortable: false,
						width: "3%"
					},
					{
						text: 'Отдел',
						value: 'dcn',
						align: 'center',
						sortable: true,
						width: "22%"
					},
					{
						text: 'Статья',
						value: 'icn',
						align: 'center',
						sortable: true,
						width: "22%"
					}
				]
				if (this.editRight || this.draftMode) {
					headers.push({
						text: 'Действия',
						value: 'actions',
						align: 'center',
						sortable: false,
						width: "5%"
					})
				}
				if (this.draftMode) {
					headers.unshift({
						text: 'Автор',
						value: 'author',
						align: 'center',
						sortable: true,
						width: "10%"
					})
				}
				return headers
			},
			editRight() {
				return this.$store.getters.userHasRight('pl_expense_guide_edit')
			},
			editDraftRight() {
				return this.$store.getters.userHasRight('pl_expense_guide_edit_draft')
			}
		},
		watch: {
		},
		mounted() {
			this.search = this.$route.params.search
			if (this.search) this.doSearch()
		},
		methods: {
			newItem() {
				this.getDc()
				this.dialogEdit.index = 0
				this.dialogEdit.new = true

				let regexp = /[а-яё]/i

				if (regexp.test(this.search)) {
					this.dialogEdit.item = {
						nameEng: '',
						nameRus: _.upperFirst(this.search),
						dc: '',
						ic: ''
					}
				}
				else {
					this.dialogEdit.item = {
						nameEng: _.upperFirst(this.search),
						nameRus: '',
						dc: '',
						ic: ''
					}
				}

				this.dialogEdit.show = true
				if (this.$refs.f != undefined) this.$refs.f.resetValidation()
			},
			add() {
				if (!this.dialogEdit.valid) return

				let item = this.dialogEdit.item

				api.post('expenseguide/add_item', {
					nameEng: item.nameEng,
					nameRus: item.nameRus,
					dc: item.dc,
					ic: item.ic
				})
				.then(response => {

					if (this.editRight) {
						this.data.push(item)
						let addedItem = this.data[this.data.length - 1]
						// if (!addedItem.dc) addedItem.dc = ''
						// if (!addedItem.ic) addedItem.ic = ''
						addedItem.id = response.data.id
						addedItem.dcn = this.dc.find(el => el.code == addedItem.dc).name.split(': ')[1]
						addedItem.icn = this.ic.find(el => el.code == addedItem.ic).name.split(': ')[1]
						this.len = this.len + 1
					}

					this.dialogEdit.show = false

				}, error => {})
			},
			save() {
				if (!this.dialogEdit.valid) return

				let item = this.dialogEdit.item

				api.post('expenseguide/change_item', {
					id: item.id,
					nameEng: item.nameEng,
					nameRus: item.nameRus,
					dc: item.dc,
					ic: item.ic
				})
				.then(response => {

					let changedItem = this.data[this.dialogEdit.index]
					Object.assign(changedItem, item)
					if (!changedItem.dc) changedItem.dc = ''
					if (!changedItem.ic) changedItem.ic = ''
					changedItem.dcn = this.dc.find(el => el.code == changedItem.dc).name.split(': ')[1]
					changedItem.icn = this.ic.find(el => el.code == changedItem.ic).name.split(': ')[1]

					this.dialogEdit.show = false

				}, error => {})
			},
			close() {
				this.dialogEdit.show = false
			},
			edit(item) {
				this.getDc()
				this.dialogEdit.index = this.data.indexOf(item)
				this.dialogEdit.new = false
				this.dialogEdit.item = Object.assign({}, item)
				// if (this.dialogEdit.item.dc == '') this.dialogEdit.item.dc = 0
				// if (this.dialogEdit.item.ic == '') this.dialogEdit.item.ic = 0

				this.getIc()

				if (this.$refs.f != undefined) this.$refs.f.validate()

				this.dialogEdit.show = true
			},
			del(item) {
				let index = this.data.indexOf(item)

				this.$store.dispatch('dialogConfirm', {
					title: 'Подтверждение',
					message: 'Удалить запись?'
				})
				.then(confirm => {
					if (confirm) {
						api.post('expenseguide/del_item', {
							id: item.id
						})
						.then(response => {

							this.data.splice(index, 1)
							this.len = this.len - 1

						}, error => {})
					}
				})
			},
			saveAndApprove() {
				this.save()
				this.approve(this.data[this.dialogEdit.index])
			},
			approve(item) {
				let index = this.data.indexOf(item)

				api.post('expenseguide/approve_draft', {
					id: item.id
				})
				.then(response => {

					this.data.splice(index, 1)
					this.len = this.len - 1

				}, error => {})
			},
			getDc() {
				if (!this.dcLoaded) {
					api.post('common/get_dc', {
						pl: true,
						mult: true,
						nameFormat: 'id: rusName / engName'
					})
					.then(response => {

						this.dc = response.data.data
						// this.getIc()

						this.dcLoaded = true

					}, error => {})
				}
			},
			getIc() {
				api.post('common/get_ic', {
					dc: this.dialogEdit.item.dc,
					mult: true,
					open_to_input: true,
					nameFormat: 'code: descrRu / descrEn'
				})
				.then(response => {
					this.ic = response.data.data
				}, error => {})
			},
			doSearch() {
				this.loadingList = true
				this.searchDone = false

				api.post('expenseguide/search', {
					search: this.search
				})
				.then(response => {

					let url = this.search ? '/expenses/' + encodeURI(this.search) : '/expenses/'

					this.$router.push(url)
					this.data = response.data.data
					this.len = response.data.len

					this.loadingList = false
					this.searchDone = !!this.search
					this.draftMode = false

				}, error => {})
			},
			getDrafts() {
				this.loadingList = true
				this.searchDone = false
				this.search = ''

				api.post('expenseguide/get_drafts')
				.then(response => {

					this.data = response.data.data
					this.len = response.data.len

					this.loadingList = false
					this.searchDone = true
					this.draftMode = true

				}, error => {})
			},
			codes(dc, ic) {
				if (dc == 0) dc = '*'
				if (ic == 0) ic = '*'
				return dc + ' - ' + ic
			},
		}
	}
</script>
